import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, SecurityContext } from '@angular/core';
import { UiLinkModule } from '@big-direkt/ui/link';
import { UiPictureModule } from '@big-direkt/ui/picture';
import { UiSvgIconModule } from '@big-direkt/ui/svg-icon';
import { IconBigMediumPfeilRechts, IconComponent } from '@big-direkt/utils/icons';
import { Nl2brPipe, SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardComponent } from '../card/card.component';
import { UiCardImageHlTextLinkModel } from './card-image-hl-text-link.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'big-ui-card-image-hl-text-link',
    templateUrl: './card-image-hl-text-link.component.html',
    imports: [CardComponent, DatePipe, IconComponent, NgClass, Nl2brPipe, SanitizePipe, TranslocoDirective, UiLinkModule, UiPictureModule, UiSvgIconModule],
})
export class CardImageHlTextLinkComponent {
    public readonly securityContext: SecurityContext = SecurityContext.HTML;
    public readonly iconArrowRight = IconBigMediumPfeilRechts;

    @Input() public data!: UiCardImageHlTextLinkModel;
    @Input() public hideLink = false;
    @Input() public imagePlacement: 'left' | 'right' | 'top' = 'top';
}
